import React, { useState, useCallback } from "react";
import ValidationInfo from "../../common/ValidationInfo";
import { validateBusinessName } from "../../../utils/Validators";

/**
 * Modal do tworzenia kopii wniosku
 */
const CopyApplicationModal = ({ appName, onConfirm, onCancel }) => {
  const [newDraftName, setNewDraftName] = useState(
    appName ? `${appName} (kopia)` : ""
  );
  const [isValid, setIsValid] = useState(
    appName ? validateBusinessName(appName) : false
  );
  const [isLoading, setIsLoading] = useState(false);

  const handleNameChange = useCallback((e) => {
    const value = e.target.value;
    setNewDraftName(value);
    setIsValid(validateBusinessName(value));
  }, []);

  const handleConfirm = async () => {
    if (!isValid) return;

    setIsLoading(true);
    try {
      await onConfirm(newDraftName);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div
        className="modal-content card d-flex flex-column w35 p-2"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header mb-1">
          <h4>Kopia wniosku</h4>
          <button
            type="button"
            className="btn-close"
            onClick={onCancel}
            aria-label="Close"
          />
        </div>

        <div className="flex-column mb-2">
          <div className="d-flex flex-row align-items-center mb-2">
            <label htmlFor="draftName" className="form-label mb-0">
              Nazwa robocza kopii
            </label>
            <ValidationInfo
              visible={!isValid}
              title="Wypełnienie pola jest obowiązkowe. Maksymalna ilość znaków - 160"
              wide={true}
            />
          </div>
          <input
            type="text"
            id="draftName"
            className={`form-control ${
              !isValid && newDraftName ? "is-invalid" : ""
            }`}
            value={newDraftName}
            onChange={handleNameChange}
            placeholder="Wprowadź nazwę roboczą nowego wniosku"
            disabled={isLoading}
          />
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-outline-primary w7 h2"
            onClick={onCancel}
            disabled={isLoading}
          >
            Anuluj
          </button>
          <button
            type="button"
            className="btn btn-primary w7 ms-1 h2"
            onClick={handleConfirm}
            disabled={!isValid || isLoading}
          >
            {isLoading ? "Tworzę kopię..." : "Zapisz"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CopyApplicationModal;

